import { render, staticRenderFns } from "./GroupDocumentsPage.vue?vue&type=template&id=18a25b9a&scoped=true&"
import script from "./GroupDocumentsPage.vue?vue&type=script&lang=js&"
export * from "./GroupDocumentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a25b9a",
  null
  
)

export default component.exports